<template>
    <footer class="bg-[#ededed] pb-[30px] text-sm fixed bottom-0 left-0 z-20 w-full h-[6%]">
        <div class="fixed bottom-0 left-0 z-20 w-full h-[4%] flex justify-center">
            <strong class="pr-2">nanoo.tv ist ein Produkt der Werft22 AG </strong>
            © All Rights Reserved
        </div>
    </footer>
</template>
